import React, { useContext, useEffect, useState } from "react";
import StepperNavigation from "../../Components/StepperNavigation.tsx/StepperNavigation";
import LoanType from "./LoanType";
import LoanApplication from "./LoanApplication";
import StatusApprovalScreen from "./StatusApprovalScreen";
import { useLocation } from "react-router-dom";
import { loanModuleGetPersonalDetailsByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useSelector } from "react-redux";

const ApplyLoan = (props) => {
 
  const context = getContext();
  let MemberId = context.MemberId;
  const [activeStep, setActiveStep] = useState(0);
  const [stepsststatus, setStepStatus] = useState([false, false, false, false]);
  const [stepIndex, setStepIndex] = useState(0);
  const [isResetClicked, setIsResetClicked] = useState(false);
  const { state } = useLocation();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const loanParameters = useSelector<any>((state) => state?.LoanModuleReducer?.loanParameters);

  // const encryptedMemberid =
  //   GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  // const memberid = context?.MemberId; // Decrypt(encryptedMemberid);

  // useEffect(() => {
  //   if (isResetClicked) {
  //     if (steps[stepIndex].isEnable || steps[stepIndex].completed) {
  //       setActiveStep(stepIndex);
  //       setStepStatus((prev) =>
  //         prev.map((d, index) => index < stepIndex && (d = true))
  //       );
  //     }
  //   }
  // }, [isResetClicked, stepIndex]);

  const [steps, setSteps] = useState([
    {
      label: "Loan Type",
      completed: false,
      index: 0,
      isEnable: true,
    },
    {
      label: "Loan Application",
      completed: false,
      index: 1,
      isEnable: false,
    },
    {
      label: "Status",
      completed: true,
      index: 2,
      isEnable: true,
    },
  ]);

  useEffect(() => {
    getMemberIdStatusDetails();
  }, []);

  // const activateEnableTabs = () => {
  //   setActiveStep(1);
  // };

  const getMemberIdStatusDetails = async () => {
    let requestParams = loanParameters;
    // let requestParams = { LoanId: state.Id, MemberId: MemberId };
     
    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    ); 
    // setStatusData(res?.Data);
    
    if (res.Message === "Ok" && res.Data !== null) {
      const Lrd_StatusId = res.Data.Lrd_StatusId;
      const Lrs_StatusId = res.Data.Lrs_StatusId;

      if (
        [LoanStatus.LoanModule_RejectedByInternalTeam].includes(Lrd_StatusId)
      ) {
        enabledStep([0, 1]);
        enablStepStatus(1);
        setActiveStep(1);
        setCompletedSteps(1);
      } else if (
        [LoanStatus.LoanModule_AllSuretyApproved].includes(Lrd_StatusId)
      ) {
        enabledStep([0, 1]);
        enablStepStatus(1);
        setActiveStep(1);
        setCompletedSteps(1);
      } else if (
        [LoanStatus.LoanModule_SuretyApprovalPending].includes(Lrd_StatusId)
      ) {
        if (
          [
            LoanStatus.LoanModule_SuretyApprovalPending,
            LoanStatus.LoanModule_SuretyRejectedByMember
          ].includes(Lrs_StatusId)
        ) {
          enabledStep([0, 1]);
          enablStepStatus(1);
          setActiveStep(1);
          setCompletedSteps(1);
        }
      } else if ([LoanStatus.LoanModule_Draft].includes(Lrd_StatusId)) {
        enabledStep([0, 1]);
        enablStepStatus(1);
        setActiveStep(1);
        setCompletedSteps(1);
      } else if (
        [LoanStatus.LoanModule_PendingWithInternalTeam].includes(Lrd_StatusId)
      ) {
        enabledStep([0, 1, 2]);
        enablStepStatus(2);
        setActiveStep(2);
        setCompletedSteps(2);
      }
      return res?.Data;
    }
  };

  const enabledStep = (stepIds) => {
    if (stepIds) {
      let tempData = steps.map((st) => {
        if (stepIds.includes(st.index)) {
          return { ...st, isEnable: true };
        } else {
          return { ...st, isEnable: false };
        }
      });
      setSteps(tempData);
      setIsResetClicked(true);
    }
  };

  const enablStepStatus = (id) => {
    if (id) {
      let tempData = stepsststatus.map((ss, index) => {
        if (index <= id) {
          return true;
        } else {
          return false;
        }
      });
      setStepStatus(tempData);
    }
  };

  const setCompletedSteps = (stepNo) => {
    let tempData = steps;
    if (stepNo == -1) {
      tempData = steps.map((ss) => {
        return { ...ss, completed: false };
      });
    } else {
      tempData = steps.map((ss) => {
        if (ss.index <= stepNo) {
          return { ...ss, completed: true };
        } else {
          return { ...ss, completed: false };
        }
      });
    }
    setSteps(tempData);
  };

  const handleNextStep = async (stepIndex) => {
  
    // setStepIndex(stepIndex);
    let statusDetails = await getMemberIdStatusDetails();
    
   
    if (steps[stepIndex].isEnable || steps[stepIndex].completed) {
      setActiveStep(stepIndex);
      setStepStatus((prev) =>
        prev.map((d, index) => index < stepIndex && (d = true))
      );
    }
    return statusDetails;
  };

  return (
    <div style={{ width: "100%" }}>
      <StepperNavigation
        steps={steps}
        activeStep={activeStep}
        directStep={async (e) => await handleNextStep(e)}
        navigationBox={{
          0: (
            <LoanType
              next={async () => await handleNextStep(1)}
              statusData={props.statusData}
            />
          ),
          1: (
            <LoanApplication
              next={async () => await handleNextStep(2)}
              statusData={props.statusData}
            />
          ),
          2: (
            <StatusApprovalScreen
              next={async () => await handleNextStep(3)}
              statusData={props.statusData}
            />
          ),
        }}
      />
    </div>
  );
};

export default ApplyLoan;
